import React, { useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Center,
} from "@chakra-ui/react";
import TradingSpinner from "../TradingSpinner";

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColorScheme = "blue",
  isLoading = false,
  isConfirmDisabled = false,
  closeOnOverlayClick = true,
  motionPreset = "slideInBottom",
  isCentered = true,
  size,
  contentProps,
}) => {
  const cancelRef = useRef();

  return (
    <AlertDialog
      motionPreset={motionPreset}
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered={isCentered}
      closeOnOverlayClick={closeOnOverlayClick}
      size={size}
    >
      <AlertDialogOverlay>
        {isLoading ? (
          <AlertDialogContent {...contentProps}>
            <Center p={6}>
              <TradingSpinner size="40px" />
            </Center>
          </AlertDialogContent>
        ) : (
          <AlertDialogContent {...contentProps}>
            {title && (
              <AlertDialogHeader fontSize="lg" fontWeight="bold" pb={1}>
                {title}
              </AlertDialogHeader>
            )}
            <AlertDialogBody pt={1}>{children}</AlertDialogBody>
            <AlertDialogFooter paddingTop={4}>
              <Button ref={cancelRef} borderRadius="md" onClick={onClose}>
                {cancelLabel}
              </Button>
              {onConfirm && (
                <Button
                  colorScheme={confirmColorScheme}
                  borderRadius="md"
                  onClick={onConfirm}
                  isDisabled={isConfirmDisabled}
                  ml={3}
                >
                  {confirmLabel}
                </Button>
              )}
            </AlertDialogFooter>
          </AlertDialogContent>
        )}
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default ConfirmDialog;
